import { useContext } from 'react'
import { ResponsiveContext } from './ResponsiveContext'

export const useFontScale = () => useContext(ResponsiveContext).fontScaled
